import { Component, OnInit } from '@angular/core';
import { ButtonsComponent } from 'gung-standard';
import { first, takeUntil } from 'rxjs';

@Component({
    selector: 'ref-buttons',
    templateUrl: './ref-buttons.component.html',
    styleUrls: ['./ref-buttons.component.scss'],
    standalone: false
})
export class RefButtonsComponent extends ButtonsComponent implements OnInit{
  
  margin = 0;
  marginPercent = 0;
  ngOnInit() {
    this.updateData();

    this.authService
      .getRoles()
      .pipe(first())
      .subscribe(roles => {
        this.isSales = roles.indexOf('SALES') > -1;
        this.isAdmin = roles.indexOf('ADMIN') > -1;
        this.isUser = roles.indexOf('USER') > -1 && !this.isSales && !this.isAdmin;
      });

    this.navbarCartService
      .getContents()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(contents => {
        this.margin = 0;
        this.cartContents = contents;
        console.log('this.cartContents', this.cartContents);
        this.cartTotalValue = contents.totalValue;
        for (const row of this.cartContents.rows) {            
            const priceProductTotal = row.price.cartRowTotalPriceInclRowDiscount.value;
            const qty = row.cartRow.qty;
            const totalCost = row.product.extra.ar.artkalkpris * qty;
            this.margin = this.margin + (priceProductTotal - totalCost);
        }
        if(this.cartContents.totalValue){
          this.marginPercent = (this.margin *100) / this.cartContents.totalValue;
        }else{
          this.marginPercent = -100;
        }
        
        this.applyDiscountToTotalValue(null, this._discountCode);
        this.cartCurrency = contents.currency;
        this.cartTotalRows = contents.rows.length;
        this.cartTotalItems = contents.rows.map(row => row.cartRow.qty).reduce((acc, curr) => acc + curr, 0);
      });
  }
}
